module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MaterialShareView.js"));
	}, "MaterialShareView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MaterialShareView!./src/pages/Share/MaterialShare/MaterialShareView.js
// module id = 1174
// module chunks = 438